// extracted by mini-css-extract-plugin
export default {"market":"Market_market__CoKLM","content":"Market_content__O9Dam"};